/**
 * Compare Boards Contract — typed API contract for document comparison.
 *
 * All types derived from generated Zod schemas (OpenAPI-first).
 * Maps to: core/app/schemas/compare_board.py
 */

import { z } from 'zod';

import {
  zCompareBoardRead as GeneratedCompareBoardRead,
  zCompareBoardCreate as GeneratedCompareBoardCreate,
  zCompareBoardPatch as GeneratedCompareBoardPatch,
} from '@/api/generated/hey-api/zod.gen';

import type { PaginatedResponse } from './shared';

// ─── Schemas ────────────────────────────────────────────────────────────────

export const CompareBoardReadSchema = GeneratedCompareBoardRead;
export type CompareBoardRead = z.infer<typeof CompareBoardReadSchema>;

export const CompareBoardCreateSchema = GeneratedCompareBoardCreate;
export type CompareBoardCreate = z.infer<typeof CompareBoardCreateSchema>;

export const CompareBoardPatchSchema = GeneratedCompareBoardPatch;
export type CompareBoardPatch = z.infer<typeof CompareBoardPatchSchema>;

// ─── Response types ─────────────────────────────────────────────────────────

export type CompareBoardListResponse = PaginatedResponse<CompareBoardRead>;
